import { takeLatest } from 'redux-saga/effects';

import { inviteControlModel } from '@features/invite-control';

export function* booksPageWorker() {
  yield takeLatest(inviteControlModel.actions.acceptInviteClick, inviteControlModel.sagas.acceptInviteSaga);
  yield takeLatest(inviteControlModel.actions.rejectInviteClick, inviteControlModel.sagas.rejectInviteAction);
}
